<script type="ts">
    import { Modal, NumberInput, RadioTile, Select, SelectItem, TileGroup } from "carbon-components-svelte";
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
	import { Localized } from '@nubolab-ffwd/svelte-fluent';
    import { WallConfig} from '../scene-manager';

	const { getTranslation } = stores();

    export let open;
    export let newScene: SceneConfig;

    $: {
        newScene.width = Math.round(newScene.width);
        if (newScene.width < 1) {
            newScene.width = 1;
        } else if (newScene.width > 10) {
            newScene.width = 10;
        }

        newScene.depth = Math.round(newScene.depth);
        if (newScene.depth < 1) {
            newScene.depth = 1;
        } else if (newScene.depth > 10) {
            newScene.depth = 10;
        }
    }

</script>

<Modal
    size="xs"
    bind:open
    modalHeading={$getTranslation("config-title").value}
    primaryButtonText={$getTranslation("config-continue").value}
    secondaryButtonText={$getTranslation("config-cancel").value}
    on:click:button--secondary
    on:open
    on:close
    on:submit
>
    <p><Localized id="config-intro" /></p>
    <div class="input-row">
        <NumberInput label={$getTranslation("config-width").value} min={1} max={10} step={1} bind:value={newScene.width}/>
        <NumberInput label={$getTranslation("config-depth").value} min={1} max={10} step={1} bind:value={newScene.depth}/>
    </div>
    <div class="select-row">
        <Select labelText={$getTranslation("config-wallheight").value} selected="250" on:change={(event) => newScene.height = event.detail}>
            <SelectItem value="200" text="2 m" />
            <SelectItem value="250" text="2,5 m" />
            <SelectItem value="300" text="3 m" />
            <SelectItem value="350" text="3,5 m" />
            <SelectItem value="400" text="4 m" />
        </Select>
    </div>
    <TileGroup legend={$getTranslation("config-type").value} on:select={(v) => newScene.wall = v.detail}>
        <RadioTile value={WallConfig.U} checked={newScene.wall === WallConfig.U}><span class="wallicon wallicon--u"></span><Localized id="config-walls-u" /></RadioTile>
        <RadioTile value={WallConfig.Back} checked={newScene.wall === WallConfig.Back}><span class="wallicon wallicon--back"></span><Localized id="config-walls-back" /></RadioTile>
        <RadioTile value={WallConfig.Left} checked={newScene.wall === WallConfig.Left}><span class="wallicon wallicon--left"></span><Localized id="config-walls-left" /></RadioTile>
        <RadioTile value={WallConfig.Right} checked={newScene.wall === WallConfig.Right}><span class="wallicon wallicon--right"></span><Localized id="config-walls-right" /></RadioTile>
        <RadioTile value={WallConfig.None} checked={newScene.wall === WallConfig.None}><span class="wallicon wallicon--none"></span><Localized id="config-walls-none" /></RadioTile>
    </TileGroup>
</Modal>